"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluckRelationshipIds = exports.pluckRelationshipId = exports.normalizeResource = exports.createRelationships = exports.createRelationship = void 0;
/**
 * Safely creates a JSON:API to-one `Relationship` object from an ID.
 */
function createRelationship(id, create) {
    return id === undefined ? undefined : { data: id === null ? null : create(id) };
}
exports.createRelationship = createRelationship;
/**
 * Safely creates a JSON:API to-many `Relationship` object from a collection of IDs.
 */
function createRelationships(ids, create) {
    return ids === undefined ? undefined : { data: ids.map(create) };
}
exports.createRelationships = createRelationships;
function normalizeResource(resource) {
    if (resource.attributes !== undefined && !hasDefinedProperties(resource.attributes)) {
        delete resource.attributes;
    }
    if (resource.relationships !== undefined && !hasDefinedProperties(resource.relationships)) {
        delete resource.relationships;
    }
    return resource;
}
exports.normalizeResource = normalizeResource;
/**
 * Safely retrieves the resource ID defined in a JSON:API `Relationship` object.
 * @returns the related resource's ID. `null` if there is no relationship.
 */
function pluckRelationshipId(relationship) {
    return (relationship === null || relationship === void 0 ? void 0 : relationship.data) === null ? null : relationship.data.id;
}
exports.pluckRelationshipId = pluckRelationshipId;
/**
 * Safely retrieves the resource IDs from a to-many relationship defined in a JSON:API `Relationship` object.
 * @returns the related resources' IDs.
 */
function pluckRelationshipIds(relationship) {
    return relationship.data.map((identifier) => identifier.id);
}
exports.pluckRelationshipIds = pluckRelationshipIds;
function hasDefinedProperties(subject) {
    const keys = Object.keys(subject);
    return keys.length > 0 && keys.some((key) => subject[key] !== undefined);
}
//# sourceMappingURL=jsonapi-utils.js.map